export type Testimonial = {
  id: string
  quote: string
  name: string
  role: string
}

export const testimonials: Testimonial[] = [
  {
    id: 'marden',
    quote:
      'We used to spend a day a week chasing invoices. Credit Manager took that off our plate entirely — and our debtor days dropped from 61 to 29 in the first quarter.',
    name: 'Rachel Okonjo',
    role: 'Finance Director, Marden Fabrication Ltd',
  },
  {
    id: 'holbeck',
    quote:
      'The credit checks paid for the subscription in the first month. We turned down two orders that would almost certainly have gone bad.',
    name: 'Tom Bridgeman',
    role: 'Managing Director, Holbeck Supplies',
  },
  {
    id: 'kestrel',
    quote:
      'It connected to Xero in minutes and the reminders just run. Our customers pay earlier and nobody here has to be the bad guy.',
    name: 'Priya Raman',
    role: 'Operations Manager, Kestrel Interiors',
  },
  {
    id: 'ashdown',
    quote:
      'Being able to draw against a single invoice when we needed to cover payroll made all the difference. No long-term commitment, no fuss.',
    name: 'Daniel Whyte',
    role: 'Owner, Ashdown Joinery',
  },
]
